import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useAccordionStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordion: {
      border: `1px solid ${theme.palette.divider}`,
    },
    accordionDetails: {
      padding: theme.spacing(2),
      paddingBottom: 0,
      borderTop: '1px solid rgba(0, 0, 0, .125)',
    },
    accordionSummary: {
      backgroundColor: 'rgba(0, 0, 0, .03)',
      flexDirection: 'row-reverse',
      '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
      },
      '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
      },
    },
  })
);

export default useAccordionStyles;
